import React, { useState, useEffect } from "react";
import { MrecAdContainer } from "./styles";
import MrecImg from "./mrec.jpg";

const MrecAd = (props) => {
  const { hide } = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.src = MrecImg;
  }, []);

  if (hide) return null;

  if (!imageLoaded) return null;

  return (
    <MrecAdContainer
      href="https://www.aveo.com.au/retirement-villages/nsw/?utm_source=downsizing&utm_medium=display&utm_campaign=pc-ao_ct-gen_p2_srv-retv_ns-nsw_&utm_content=native_html&dclid=CPXYwPS89Y8DFTejZgId84wfzQ&gad_source=7"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img 
        src={MrecImg} 
        alt="MREC"
        onLoad={() => setImageLoaded(true)}
        onError={() => console.error('Failed to load MREC image')}
      />
    </MrecAdContainer>
  );
};

export default MrecAd;
